<div class="article-container">
  <app-button
    icon="keyboard_backspace"
    type="tertiary"
    iconPosition="left"
    size="medium"
    [text]="'trends-inspirations.back-to-articles' | translate"
    (click)="goBack()">
  </app-button>
  <builder-content
    [model]="ARTICLE_PAGE_MODEL"
    [content]="content"
    [apiKey]="apiKey"
    [customComponents]="customComponents"
  />
</div>
